/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_6_HInputs */

const en_privacy_6_h = /** @type {(inputs: Privacy_6_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retention and deletion`)
};

const id_privacy_6_h = /** @type {(inputs: Privacy_6_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyimpanan dan penghapusan`)
};

/**
* | output |
* | --- |
* | "Retention and deletion" |
*
* @param {Privacy_6_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_6_h = /** @type {((inputs?: Privacy_6_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_6_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_6_h(inputs)
	return en_privacy_6_h(inputs)
});